import * as React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Menu from '@components/menu';
import CloseIcon from '@components/basics/icons/close';
import Typography from '@components/basics/typography';
import DotsCircleIcon from '@components/basics/icons/dots-circle';

interface ContactMenuEditorProps {
  id: string;
  onDelete: (id: string) => void;
}

export const ContactMenuEditor: React.FC<ContactMenuEditorProps> = ({
  id,
  onDelete,
}) => {
  return (
    <Menu
      className="menu"
      button={<DotsCircleIcon className="open-icon" />}
      closeButton={<CloseIcon className="close-icon" />}
      customIconHeight="24px"
      menuId={`USER-EDITOR-MENU-${id}`}
    >
      <MenuContent>
        <Typography
          weight="700"
          className="menu-item danger"
          onClick={() => onDelete(id)}
        >
          <Translate id="USER_PROFILE.GENERAL.EMAIL_PHONE.DELETE" />
        </Typography>
      </MenuContent>
    </Menu>
  );
};

const MenuContent = styled.div`
  display: grid;
  grid-gap: 5px;
  min-width: 128px;

  .menu-item {
    cursor: pointer;
    transition: color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      color: ${({ theme }) => theme.colors.tertiary};
    }

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
      cursor: not-allowed;
    }

    &.danger {
      color: ${({ theme }) => theme.colors.accent};
      &:hover {
        color: ${({ theme }) => theme.colors.accentHover};
      }
    }
  }
`;
